
    export default {
      mounted() {
        this.el.addEventListener("click", () => window.print())
      }
    }
  